import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=766735b3&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766735b3')) {
      api.createRecord('766735b3', component.options)
    } else {
      api.reload('766735b3', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=766735b3&", function () {
      api.rerender('766735b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2529HyhDyRHGb/JS/cancellationPolicy.vue"
export default component.exports